var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.deckLoading}}),_vm._v(" "),_c('deck-header'),_vm._v(" "),_c('deck-subheader'),_vm._v(" "),_c('div',{staticClass:"mt--300 grid-col grid-col--12",staticStyle:{"height":"50px"}}),_vm._v(" "),_c('deck-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }